import { qrListAtom } from 'features/library/client'

import { qrCodesApi } from '@/generator/shared'
import { getStore } from '@/store'

export const refreshQrList = async () => {
	try {
		const { data } = await qrCodesApi.getQrList()
		getStore().set(qrListAtom, data)
	} catch (error) {
		console.error('Failed to fetch QR list:', error)
	}
}
